<template>
    <v-container fluid>

        <v-layout row>
            <h1>NTT DATA Technology Radars
              <v-btn
                  style="margin-top: -2px; margin-left: 15px;"
                  small
                  icon
                  @click="dialogGuidelines=true"
              >
                <v-icon>mdi-information-outline</v-icon>
              </v-btn>
              <v-dialog v-if="!isMobile()" v-model="dialogGuidelines" max-width="60%">
                <guidelines-reader :guidelines="guidelines" />
              </v-dialog>
              <v-dialog v-else v-model="dialogGuidelines" max-width="90%">
                <guidelines-reader :guidelines="guidelines" />
              </v-dialog>
            </h1>
        </v-layout>

        <v-layout row>
            <h3>In the Tech RADAR, trends are mapped against the Digital Focus Areas. In the Biz Radar, trends are mapped against the Market Sectors. </h3>
        </v-layout>

        <v-layout row wrap align-center mt-5 class="radar-legend">
            <!-- LEGENDA RADAR -->
            <v-flex xs12 sm3 md3 lg3 xl3>
                <v-layout column justify="center">
                    <h4>Change radar type</h4>
                    <v-flex xs12 class="px-3 py-1">
                        <v-switch
                                v-model="radar_type_switch"
                                :label="radar_type_label"
                        ></v-switch>
                    </v-flex>
                    <div v-if="radar_type_switch">
                        <h4>Tech classes</h4>
                        <v-flex style="align-items: center; display: flex;" xs12 v-for="(classValue, classKey) in tech_classes" :key="classKey" class="px-3 py-1">
                            <img width="30px" :src="getImageUrl(classKey)" />
                          <span style="margin-left: 10px;">{{ classKey }}</span>
                        </v-flex>
                    </div>
                    <div v-else>
                        <h4>Biz classes</h4>
                        <v-flex style="align-items: center; display: flex;" xs12 v-for="(classValue, classKey) in biz_classes" :key="classKey" class="px-3 py-1">
                          <img width="30px" :src="getImageUrl(classKey)" />
                            <span style="margin-left: 10px;">{{ classKey }}</span>
                        </v-flex>
                    </div>


                    <h4 class="pt-4">Adoption</h4>
                    <v-flex xs12 class="px-3 py-1">
                      <div style="background: rgb(255,255,255); width: 20px;height: 20px;border: 1px solid black;margin-right: 5px; margin-left: 5px; display: inline-block;"></div>
                        ADOPT
                    </v-flex>
                    <v-flex xs12 class="px-3 py-1">
                      <div style="background: rgb(224,224,224); width: 20px;height: 20px;border: 1px solid black;margin-right: 5px; margin-left: 5px; display: inline-block;"></div>

                        TRY
                    </v-flex>
                    <v-flex xs12 class="px-3 py-1">
                      <div style="background: rgb(200,200,200); width: 20px;height: 20px;border: 1px solid black;margin-right: 5px; margin-left: 5px; display: inline-block;"></div>

                        ASSESS
                    </v-flex>

                    <h4 class="pt-4">Business Relevance</h4>
                    <v-flex xs12 class="px-3 py-1">
                        <v-icon large color="#00796b" class="pr-2">
                            mdi-circle
                        </v-icon>
                        <img width="36px" src="@/assets/img/radar/triangle.png"/>
                        HIGH
                    </v-flex>
                    <v-flex xs12 class="px-3 py-1">
                        <v-icon medium color="#00796b" class="pr-2">
                            mdi-circle
                        </v-icon>
                        <img width="28px" src="@/assets/img/radar/triangle.png"/>
                        MEDIUM
                    </v-flex>
                    <v-flex xs12 class="px-3 py-1">
                        <v-icon color="#00796b" class="pr-2">
                            mdi-circle
                        </v-icon>
                        <img width="24px" src="@/assets/img/radar/triangle.png"/>
                        LOW
                    </v-flex>

                    <h4 class="pt-4">Business Impact</h4>
                    <v-flex xs12 class="px-3 py-1">
                        <v-icon color="#f57c00" class="pr-2">
                            mdi-triangle
                        </v-icon>
                        Disruptive
                    </v-flex>
                    <v-flex xs12 class="px-3 py-1">
                        <v-icon color="#0288d1" class="pr-2">
                            mdi-circle
                        </v-icon>
                        Evolutional
                    </v-flex>

                </v-layout>
            </v-flex>

            <!-- POLAR RADAR -->
            <v-flex xs12 sm9 md9 lg9 xl9 mt-5>
                <v-card
                        color="transparent"
                        elevation="0"
                        width="100%"
                >
                    <v-layout class="justify-center">

                            <!--
                        <v-overlay :value="loadingAPI" absolute opacity="0.8">
                            <v-progress-circular
                                    indeterminate
                                    size="64"
                            ></v-progress-circular>
                        </v-overlay>
                        -->

                            <PolarRadar :input_points="trendListObjects" :radar_type="radar_type" ref="polarRadar" v-on:selectedPoint="onSelectedPoint"></PolarRadar>
                    </v-layout>
                </v-card>
            </v-flex>

        </v-layout>


        <v-layout row justify-center mt-5>
            <v-dialog v-model="trendDetailsDialog" v-if="trendDetailsDialog" max-width="80%" :fullscreen="isMobile()">
              <v-card>
                <v-toolbar
                    dark
                    color="primary"
                >
                  <v-toolbar-title> {{ this.selectedTrend.title }} </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn
                        icon
                        dark
                        @click="trendDetailsDialog = false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                  <TrendDetails :trend="selectedTrend"></TrendDetails>
                </v-card>
            </v-dialog>
        </v-layout>

    </v-container>
</template>

<script>
    import PolarRadar from "@/components/Radar/PolarRadar";
    import TrendDetails from "@/components/Radar/TrendDetails";
    import GuidelinesReader from "@/components/Radar/GuidelinesReader";
    import {mapGetters} from "vuex";
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import TrendIconMapping from "../../assets/legends/TrendIconMapping";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";

    export default {
        name: 'Radar',
        components: {
            TrendDetails,
            PolarRadar,
            TrendIconMapping,
            GuidelinesReader
        },
        data() {
            return {
                //trendIconMapping: TrendIconMapping,
                loadingAPI: false,
                isExpanded: false,
                guidelines: '<li>Each point on the plot represent a trend. Click on it to view some informations like the relative articles and the associated startups.</li>' +
                    '<li>It\'s easy to zoom the plot dragging your mouse on it and when you\'re done just double click on the view to restore its initial state.</li>',
                dialogGuidelines: false,
                trendDetailsDialog: false,
                selectedTrend: undefined,
                trendListObjects: [],
                radar_type_switch: true,
                radar_type_label: "Technology Radar"
            }
        },
        computed: {
            ...mapGetters("RadarState", {
                    tech_classes: "getTechClasses",
                    biz_classes: "getBizClasses"
                }
            ),

            radar_type: function () {
                //console.log("@@@@ switch");
                if(this.radar_type_switch){
                    this.radar_type_label = "Technology Radar";
                    return "tech"
                } else{
                    this.radar_type_label = "Business Radar";
                    return "biz"
                }
            }
        },
      created() {
        this.getTrendList();
      },
      methods: {
            isMobile() {
              return this.$vuetify.breakpoint.name === "xs";
            },
            getImageUrl(classKey){
              console.log("asad", TrendIconMapping[classKey])
              return TrendIconMapping[classKey]
              //return require('@/assets/img/trend-icons/dfa-di.png')
            },
            onSelectedPoint(value) {
                // this.selectedDocument = undefined;
                // this.isExpanded = true;
                // this.selectedDocument = value;
                console.log("@@@@ Elemento cliccato %s: ", value.title, value);
                this.selectedTrend = undefined;
                this.trendDetailsDialog = true;
                this.selectedTrend = value;
            },
        getTrendList() {

          let requestUrl = {
            url: UrlsService.getTrends,
            timeout: TimeService.secondsToMillis(0),
          };
          let requestData = {};
          let requestObject = {
            type: "radar",
            urlsInfo: requestUrl,
            data: {
              method: "get",
              data: requestData
            },
          };
          let messages = {
            title: "Get Trend List",
            loading: "Creating",
            error: "Server Error",
          };
          let options = {
            loadingType: "fullscreen",
            timeout: TimeService.secondsToMillis(0),
          };

          APILoaderDecoratorService.setLoader(requestObject, messages, options)
              .then(response => {
                this.trendListObjects = response.trends
              })
              .catch(error => {
                console.log(error)
              })
        },

        }
    }
</script>


<style lang="scss" scoped>

    /*.radar-legend {*/
    /*    position: relative;*/
    /*    bottom: -60px;*/
    /*}*/


</style>


